<div class="input-with-autocomplete"
     appClickOutside
     (clickOutside)="clickedOutside()">
  <input
         [id]="id"
         [type]="inputType"
         class="form-control form-control-search"
         [placeholder]="placeholder"
         [attr.yp-e2e-id]="e2eId"
         [value]="inputValue"
         (blur)="inputTouched()"
         [ngClass]="{'ng-invalid ng-touched' : showError}"
         (keyup)="inputValueChanged($event.target?.value)"
         autocomplete="off">

  <app-list-drop-down-select
    *ngIf="isActive && listItems.length > 0"
    (valueSelected)="listItemSelected($event)"
    [listToDisplay]="listItems"></app-list-drop-down-select>
</div>
